export default __webpack_public_path__ + "static/image-mobile-ec2e31817cffa056fed33744078d9876.png";